export * from "./components/sidebar-container";
export * from "./components/sidebar-sibling";
export * from "./components/sidebar";
export * from "./services/sidebar.service";
export * from "./sidebar.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/sidebar/index.js
// module id = 516
// module chunks = 0